<template>
    <div>
        <div class="modal fade" id="formBSModal" tabindex="-1" role="dialog" aria-labelledby="confirmModalLabel"
             aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="confirmModalLabel">{{titleValue}}</h5>
                        <button type="button" class="btn-close" @click="noHandler" aria-label="Close">

                        </button>
                    </div>
                    <div class="modal-body" v-if="document && table">
                        <div v-for="field in table.fields">
                            <form-field-container class="my-2" :table="table" :field="field" :document="document"></form-field-container>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" @click="yesHandler">save</button>
                        <button type="button" class="btn btn-secondary " @click="noHandler">cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import FormFieldContainer from "./FormFieldContainer.vue";
    export default {
        name: 'FormModal',
        components: {FormFieldContainer},
        props: {
            yesEvent: Function,
            table: Object,
            document: Object
        },
        computed: {
            titleValue() {
                return this.document['id'] ? 'Edit' : 'New'
            }
        },
        data () {
            return {
                model: webase.model,
                currentModal: null,
                modalElement: null,
            }
        },
        mounted() {
            this.modalElement = document.getElementById('formBSModal')
            this.currentModal = new bootstrap.Modal(this.modalElement)
            this.modalElement.addEventListener('hidden.bs.modal', this.onModalHidden)
            this.currentModal.show()
        },
        beforeUnmount() {
            this.modalElement.removeEventListener('hidden.bs.modal', this.onModalHidden)
        },
        methods: {
            onModalHidden() {
                this.$emit('noEvent')
            },
            noHandler(e) {
                this.currentModal.hide()
            },
            yesHandler(e) {
                // call the parent's "yesEvent"
                this.yesEvent()
                // hide the modal
                this.noHandler()
            }
        }
    }
</script>
